// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Image from '../../../image/image';

// Styles
import BlogPostImagesStyles from './blogPostImages.styles';

export default function BlogPostImages({ layout }) {
  const images = layout?.images;
  const duo = images.length >= 2;

  const caption = layout?.caption;

  return (
    <BlogPostImagesStyles duo={duo}>
      <figure className="wrapper">
        {images.map((image) => (
          <Image image={image.image} filter={image?.filter} className="image" />
        ))}
      </figure>
      {caption && <figcaption className="caption">{caption}</figcaption>}
    </BlogPostImagesStyles>
  );
}

BlogPostImages.propTypes = {
  layout: PropTypes.shape({
    images: PropTypes.arrayOf({}),
    caption: PropTypes.string,
  }),
};

BlogPostImages.defaultProps = {
  layout: {},
};
